import { ProjectModule } from 'providers/api';
import { Authorise, Permission } from 'providers/authorisation';
import { useProject } from './providers/project';

interface ProjectAuthoriseProps {
  module?: ProjectModule;
  permission?: Permission;
  children?: React.ReactNode;
  render?: (isAuthorised: boolean) => React.ReactNode;
}

const ProjectAuthorise = ({ module, permission, children, render }: ProjectAuthoriseProps) => {
  const { state: { projectId, clientId, enabledModules } } = useProject();

  if (module !== undefined && !enabledModules.some((validModule) => validModule === module)) return <></>;
  if (permission === undefined) {
    return render
      ? <>render(false)</>
      : <>{children}</>;
  }

  return (
    <Authorise
      permission={permission}
      teamId={projectId}
      render={(isProjectAuthorised) => {
        if (isProjectAuthorised) {
          return <>{render ? render(true) : children}</>;
        }

        // Then check for client permission
        return (
          <Authorise teamId={clientId} permission={permission} render={render}>
            {children}
          </Authorise>
        );
      }}
    />
  );
};

export default ProjectAuthorise;
